module.exports = __webpack_public_path__ + "cad3a8af2fe685afa291118b9de73725.svg";